import SaleCreateButton from './SaleCreateButton';

export default SaleCreateButton;